import api from './api';

export const getPointOfSales = async () => {
  const response = await api.get('/configuration/point-of-sales');
  return response.data;
};

export const getPointOfSale = async (id) => {
  const response = await api.get(`/configuration/point-of-sales/${id}`);
  return response.data;
};

export const createPointOfSale = async (data) => {
  const response = await api.post('/configuration/point-of-sales', data);
  return response.data;
};

export const updatePointOfSale = async (id, data) => {
  const response = await api.put(`/configuration/point-of-sales/${id}`, data);
  return response.data;
};

export const deletePointOfSale = async (id) => {
  const response = await api.delete(`/configuration/point-of-sales/${id}`);
  return response.data;
};

